<div class="componentRoot">
    <div echarts [options]="chartOption" class="chart" [class.saving]="saving" #chart></div>
    <button (click)="close()" class="closeButton"><fa-icon [icon]="appIcons.dialogClose"></fa-icon></button>
    <button *ngIf="allowSave" mat-flat-button color="primary" class="saveButton" (click)="save()"><fa-icon [icon]="appIcons.addChart"></fa-icon> {{'Chart.addAsImage'|translate}}</button>
</div>
